import React from 'react';

import '../style.css';
import CONF from '../Conf';
import LearnMoreButton from '../Buttons/LearnMore';

export default function BlogCard({
  language,
  body,
  iconUrl,
  title,
  fontColor,
  backgroundColor,
  link,
  imageLink,
  abTest,
}) {
  const fColor = CONF.color(fontColor);
  const trimmedImagePath = imageLink.replace('||||', '');
  return (
    <article
      className='Blog Card'
      language={language}
      id={abTest}
      style={{
        backgroundImage: `url(${trimmedImagePath})`,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backgroundBlendMode: 'multiply',
      }}>
      <header>
        <img src={iconUrl} alt='' />
        <h1 style={{ color: fColor }}>{title}</h1>
        <section style={{ color: fColor }}>
          <p>{body}</p>
        </section>
      </header>
      <footer>
        <LearnMoreButton redirectLinkOnClick={link} fillColor={fColor} language={language} />
      </footer>
    </article>
  );
}
